import React from "react";
import { Sun, Moon } from "lucide-react";

const ThemeToggleButton = ({ theme, toggleTheme, t }) => (
  <button
    style={{
      padding: "8px",
      borderRadius: "12px",
      cursor: "pointer",
      color: theme === "light" ? "#0f172a" : "white",
      background: theme === "light" ? "rgba(0,0,0,0.1)" : "rgba(255,255,255,0.1)",
      border: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.3s ease"
    }}
    onClick={toggleTheme}
    title={theme === "light" ? t.darkModeTooltip : t.lightModeTooltip}
  >
    {theme === "light" ? <Moon size={20} /> : <Sun size={20} />}
  </button>
);

export default ThemeToggleButton;
